<template>
	<div id="main" class="column is-9">
		<section class="hero is-info welcome is-small">
			<div class="columns">
				<div class="column">
				<div class="hero-body">
				<div class="columns">
					<div class="column">   				
						<router-link to="/Newpsychic" class="button is-link add-psychic is-small"><i class="fa fa-plus"></i>&nbsp;Psychic</router-link>
						<h1 class="title">Hello, {{ username }} </h1>
					</div>
					</div>
				</div>
				</div>
			</div>
		</section>
		<section class="info-tiles">
			<div class="columns">
				<div class="column">
					<div class="tile is-ancestor has-text-centered">
						<div class="tile is-parent">
							<article class="tile is-child">
							<div class="tile-header">
								<span class="title">Revenue</span>
							</div>
							<div class="title-content" v-if="!idle">
								<p class="subtitle">
									<Spinner></Spinner>
								</p>
							</div>
							<div class="tile-content" v-if="idle">
								<p class="subtitle">
									${{ getPeriodRevenue() }}
								</p>
								<router-link class="button is-primary is-small" to="/statistics">Statistics</router-link>
							</div>
							</article>
						</div>
						<div class="tile is-parent">
							<article class="tile is-child box">
							<div class="tile-header">
								<span class="title">Approvals Waiting</span>
							</div>
							<div class="title-content" v-if="!idle">
								<p class="subtitle">
									<Spinner></Spinner>
								</p>
							</div>
							<div class="tile-content" v-if="idle">
							<p class="subtitle">
								{{ approvalCount }}
							</p>
							<router-link to="/approvals" class="button is-primary is-small">Approvals</router-link>
							</div>
							</article>
						</div>
						<div class="tile is-parent">
						<article class="tile is-child box">
							<div class="tile-header">
								<span class="title">On Call/Chat</span>
							</div>
							<div class="title-content" v-if="!idle">
								<p class="subtitle">
									<Spinner></Spinner>
								</p>
							</div>
							<div class="tile-content" v-if="idle">
							<p class="subtitle">
								{{ busyCount }}
							</p>
							<router-link class="button is-primary is-small" to="/statistics">Statistics</router-link>
							</div>
							</article>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="top-five">
			<Spinner v-if="!idle"></Spinner>
			<PsychicsByRevenue :psychics="topFive" v-if="idle" />
		</section>
	</div>
</template>

<script>
import lodash from "lodash"
import PsychicsByRevenue from '../PsychicsByRevenue.vue'
import Spinner from 'vue-simple-spinner'

export default {
	components: {
		PsychicsByRevenue,
		Spinner
	},
	data() {
		return {
			idle: false,
			busyCount: 0,
			approvalCount: 0,
			statistics: []
		}
	},
	computed: {
		username() {
			const user = JSON.parse(localStorage.getItem("user"))
			return user.username
		},
		topFive() {
			return this.statistics.slice(0, 5)
		}
	},
	methods: {
		getPeriodRevenue() {
			if (this.statistics.length > 0) {
				console.log(this.statistics)
				return lodash.sumBy(this.statistics, (s) => (parseFloat(s.total_revenue))).toLocaleString("en-US")
			}
			return 0
		}
	},
	async created() {
		const user = JSON.parse(localStorage.getItem("user"))
		this.busyCount = await this.$root.$data.getters.getBusyPsychicCount(this.$root.$data.state)
		this.approvalCount = (await this.$root.$data.getters.getApprovals(this.$root.$data.state)).length
		this.statistics = (await this.$root.$data.getters.getStatistics(this.$root.$data.state, user.user_id))[0].sort((a, b) => {
			const ar = parseFloat(a.total_revenue)
			const br = parseFloat(b.total_revenue)
			if (ar < br) { return 1}
			if (br > ar) { return -1}
			return 0
		})
		this.idle = true
	}
}
</script>